import { createReducer } from 'redux-act';
import { StateStatus } from '@alycecom/utils';

import { IDetectedCountry } from './geoIpCountry.types';
import {
  detectCountryFail,
  detectCountryRequest,
  detectCountrySuccess,
  skipDetectCountryFlow,
} from './geoIpCountry.actions';

export interface IGeoIpCountryState {
  status: StateStatus;
  detectedCountry: IDetectedCountry | null;
  isSkipped: boolean;
}

export const initialState: IGeoIpCountryState = {
  status: StateStatus.Idle,
  detectedCountry: null,
  isSkipped: false,
};

export const geoIpCountry = createReducer<IGeoIpCountryState>({}, initialState);

geoIpCountry
  .on(detectCountryRequest, state => ({
    ...state,
    status: StateStatus.Pending,
  }))
  .on(detectCountrySuccess, (state, payload) => ({
    ...state,
    status: StateStatus.Fulfilled,
    detectedCountry: payload,
  }))
  .on(detectCountryFail, state => ({
    ...state,
    status: StateStatus.Rejected,
  }));

geoIpCountry.on(skipDetectCountryFlow, state => ({
  ...state,
  isSkipped: true,
}));
